import { render, staticRenderFns } from "./WithdrawRecordIndex.vue?vue&type=template&id=1e07bf32&scoped=true&"
import script from "./WithdrawRecordIndex.vue?vue&type=script&lang=js&"
export * from "./WithdrawRecordIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e07bf32",
  null
  
)

export default component.exports